// DS9.7.5
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import DeviationBlockedOverlay from './DeviationBlocked';
import ArtistBlockedOverlay from './ArtistBlocked';
import DefaultBlockedOverlay from './DefaultBlocked';
import AntisocialBlockedOverlay from './AntisocialBlocked';
import { BlockReasons } from '../../Moderation/redux/types';
import MatureAnonymousBlockedOverlay from './MatureAnonymousBlocked';
import MatureBlockedOverlay from './MatureBlocked';
import MatureAgeBlockedOverlay from './MatureAgeBlocked';
import MatureStrictBlockedOverlay from './MatureStrictBlocked';
import NsfgBlockedOverlay from './NsfgBlocked';
const BlockedOverlay = (props)=>{
    switch(props.blockReason){
        case BlockReasons.DeviationBlocked:
            return /*#__PURE__*/ React.createElement(DeviationBlockedOverlay, _extends({}, props));
        case BlockReasons.ArtistBlocked:
            return /*#__PURE__*/ React.createElement(ArtistBlockedOverlay, _extends({}, props));
        case BlockReasons.MatureFilter:
            return /*#__PURE__*/ React.createElement(MatureBlockedOverlay, _extends({}, props));
        case BlockReasons.MatureLoggedOut:
            return /*#__PURE__*/ React.createElement(MatureAnonymousBlockedOverlay, _extends({}, props));
        case BlockReasons.MatureAge:
            return /*#__PURE__*/ React.createElement(MatureAgeBlockedOverlay, _extends({}, props));
        case BlockReasons.StrictMatureAge:
            return /*#__PURE__*/ React.createElement(MatureStrictBlockedOverlay, _extends({}, props));
        case BlockReasons.Antisocial:
            return /*#__PURE__*/ React.createElement(AntisocialBlockedOverlay, _extends({}, props));
        case BlockReasons.Nsfg:
            return /*#__PURE__*/ React.createElement(NsfgBlockedOverlay, _extends({}, props));
        case BlockReasons.BlockedByArtist:
        default:
            return /*#__PURE__*/ React.createElement(DefaultBlockedOverlay, _extends({}, props));
    }
};
BlockedOverlay.displayName = 'BlockedOverlay';
export default BlockedOverlay;
